"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PieProgressIndicator = function PieProgressIndicator(_ref) {
  var className = _ref.className,
      percentage = _ref.percentage,
      big = _ref.big;
  var calculatedPercentage = percentage * 1.58;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: className,
    size: big
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "106",
    height: "106"
  }, /*#__PURE__*/_react.default.createElement(OuterCircle, {
    r: "25",
    cx: "53",
    cy: "53",
    percentage: calculatedPercentage
  }), /*#__PURE__*/_react.default.createElement(BorderCircle, {
    r: "50",
    cx: "53",
    cy: "53"
  })));
};

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Wrapper"
})(["transform:", ";"], function (_ref2) {
  var size = _ref2.size;
  return size ? 'rotate(-90deg)' : 'rotate(-90deg) scale(0.18)';
});

var OuterCircle = _styledComponents.default.circle.withConfig({
  displayName: "OuterCircle"
})(["fill:transparent;stroke:", ";stroke-width:50;stroke-dasharray:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.brand.primary;
}, function (_ref4) {
  var percentage = _ref4.percentage;
  return "".concat(percentage, " 158");
});

var BorderCircle = _styledComponents.default.circle.withConfig({
  displayName: "BorderCircle"
})(["fill:transparent;stroke:", ";stroke-width:5;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.brand.primary;
});

PieProgressIndicator.propTypes = {
  /** The percentage that should be displayed. */
  percentage: _propTypes.number.isRequired,
  className: _propTypes.string,

  /** Set big to true to show a bigger version of the indicator. */
  big: _propTypes.bool
};
var _default = PieProgressIndicator;
exports.default = _default;